import React from 'react'

const LoanDocuments = () => {
  return (
    <div></div>
  )
}

export default LoanDocuments